import React, { useState } from "react";
import "../../shared/styles/shared-styles.css";
import ReasonCodes from "../reason-codes/ReasonCodes";
import { ReasonCode } from "../../../components/roster/cancel-shift-modal/cancel-shift-modal.ctrl";
import "./cancel-shift-modal.css";
import closeIcon from "../../../../../images/roster/close-icon.svg"

const CancelShiftModal = (props) => {
  const {
    dropdownOptions,
    onCancelShift,
    onClose,
    selectedUser,
    shiftInProgress,
  } = props;
  const firstName = selectedUser.fullname.split(' ')[0]
  const [reasonCode, setReasonCode] = useState(null);
  const [otherRCInputVisible, setOtherRCInputVisible] = useState(false);
  const [otherReasonCode, setOtherReasonCode] = useState("");
  const [reasonCodeEmpty, setReasonCodeEmpty] = useState(false);

  const onConfirmCancel = () => {
    // If reason code is not selected
    // or other reason code input is empty, show error message
    if ((reasonCode === null) || (otherRCInputVisible && !otherReasonCode)) {
      return setReasonCodeEmpty(true);
    }
    onCancelShift({ reasonCode, otherReasonCode });
  };

  const _getReasonOptions = () => {
    let dropDownOptionsFiltered = dropdownOptions
    if(shiftInProgress) {
      dropDownOptionsFiltered = dropdownOptions.filter(v => (
        v.value === ReasonCode.NO_LONGER_NEEDED
        || v.value === ReasonCode.SENT_HOME_UNQUALIFIED
      ))
    }
    return (
      <ReasonCodes
        title="" // Hide title for reason code selector
        dropdownOptions={dropDownOptionsFiltered}
        otherRCInputVisible={otherRCInputVisible}
        otherReasonCode={otherReasonCode}
        reasonCodeEmpty={reasonCodeEmpty}
        setOtherRCInputVisible={setOtherRCInputVisible}
        setOtherReasonCode={setOtherReasonCode}
        setReasonCode={setReasonCode}
        setReasonCodeEmpty={setReasonCodeEmpty}
      />
    )

  }

  return (
    <div data-testid="cancel-shift-modal" className="shift-modal-container">
      <div className="modal-body cancel-shift-modal-body">
        <div className="cancel-shift-modal-header-container">
          <span className="modal-body-header cancel-shift-modal-body-header">Cancel shift</span>
          <button
              onClick={onClose}
              className={"modal-close-button"}
          >
            <img src={closeIcon} alt="" />
          </button>
        </div>

        <span className="modal-body-description cancel-shift-modal-body-description">
        You are about to cancel 1 shift for {firstName}.
        </span>
        <span className="modal-body-description cancel-shift-modal-body-description">
           If you cancel within 24 hours of a shift’s start time you are billed
        for 4 hours of time for the crew member confirmed to work the job.
        </span>
        {_getReasonOptions()}
        <div className="modal-buttons-container">
          <button
            data-testid="on-confirm-cancel"
            className="modal-button modal-confirm-button cancel-shift-confirm-button"
            onClick={onConfirmCancel}
            disabled={reasonCode === null}
          >
            Cancel shift
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelShiftModal;
